import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VendorPaymentResponse } from '../../model/reports';

export type VendorPaymentsState = {
  data: VendorPaymentResponse | null;
  loading: boolean;
  error: string | null;
  downloadError: string | null;
  toggleValue: number;
};

const initialState: VendorPaymentsState = {
  data: null,
  loading: false,
  error: null,
  downloadError: null,
  toggleValue: 0,
};

const slice = createSlice({
  name: 'vendorPayments',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action: PayloadAction<VendorPaymentResponse>) => {
      state.loading = false;
      state.data = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    fetchFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    setDownloadError: (state, action: PayloadAction<string | null>) => {
      state.downloadError = action.payload;
    },
  },
});

export const vendorPayments = slice.reducer;
export const { fetchStart, fetchSuccess, fetchFailed, setDownloadError } = slice.actions;
